/**
 * Categorias do anexo genérico ("Arquivos"): lista fixa + "Outro" com texto
 * livre. O texto digitado em "Outro" é gravado direto na coluna `category`,
 * então uma categoria fora da lista é exibida como está.
 */

export const CATEGORY_OTHER = 'outro';

export const ATTACHMENT_CATEGORIES = [
    { value: 'exame_imagem', label: 'Exame de imagem' },
    { value: 'laudo', label: 'Laudo' },
    { value: 'receita', label: 'Receita' },
    { value: 'encaminhamento', label: 'Encaminhamento' },
    { value: CATEGORY_OTHER, label: 'Outro' }
];

export const isKnownCategory = (category) => {
    return ATTACHMENT_CATEGORIES.some(item => item.value === category);
};

/**
 * Rótulo da categoria: o da lista fixa, ou o próprio texto livre.
 */
export const getCategoryLabel = (category) => {
    if (!category) return 'Sem categoria';

    const known = ATTACHMENT_CATEGORIES.find(item => item.value === category);

    return known ? known.label : category;
};
